import { Component, OnInit } from '@angular/core';
import 'lg-zoom.js';
import 'lg-share.js';
import 'lg-video.js';
import 'lg-pager.js';
import 'lg-autoplay.js';
import 'lg-fullscreen.js';
import 'lg-hash.js';
import 'lg-thumbnail.js';
declare var lightGallery: any;
@Component({
  selector: 'app-twenty-one',
  templateUrl: './twenty-one.component.html',
  styleUrls: ['./twenty-one.component.scss']
})
export class TwentyOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
